import React, { Component } from 'react';
import moment from 'moment';
import UserHelper from '../../../../helper/user.js'
import PermissionProperties from '../../../../config/permission.js'
export default class Row extends Component{
  __RenderActionButton__(){
    var jsx = []
    if(UserHelper.HasPermission(PermissionProperties.ASSET.TRACKING.UPDATE,this.props.UserReducer)){
      jsx.push(
          <td key={this.props.data.Alias} className="text-center">
            <button type="button" onClick={()=> this.props.self.__OnTrackingUpdateCLicked__(this.props.self,this.props.data)} className="btn btn-4r btn-sm btn-primary"><i className="icon-pencil"></i>
            </button>
          </td>
      )
    }
    if(UserHelper.HasPermission(PermissionProperties.ASSET.TRACKING.DELETE,this.props.UserReducer)){
      jsx.push(
          //hide delete
          //<td className="text-center"><button type="button" onClick={()=> this.props.self.__OnTrackingDeleteCLicked__(this.props.self,this.props.data)} className="btn btn-4r btn-sm btn-danger"><i className="icon-trash"></i></button></td>
      )
    }
    return jsx
  }
  render(){
    return(
      <tr key={this.props.data.Alias}>
        <td>{this.props.data.Alias}</td>
        <td>{this.props.data.SiteName}</td>
        <td>{this.props.data.LocationName}</td>
        <td>{this.props.data.ChekinTime !== null ? moment(this.props.data.ChekinTime).format('YYYY-MM-DD h:mm:ss a'):"-"}</td>
        <td>{this.props.data.CheckoutTime !== null ? moment(this.props.data.CheckoutTime).format('YYYY-MM-DD h:mm:ss a'):"-"}</td>
        <td>{this.props.data.DueDate !== null ? moment(this.props.data.DueDate).format('YYYY-MM-DD'):"-"}</td>
        <td>{this.props.data.User}</td>
        {this.__RenderActionButton__()}
      </tr>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/asset/tracking/helper/children/row.js